









































import { Component, Vue, ProvideReactive } from 'vue-property-decorator';
import { GET_PAYCHECK } from '@/queries/Paycheck';
import PaycheckForm from '@/components/Paycheck/PaycheckForm.vue';
import DocumentPage from '@/components/Invoicing/Shared/DocumentPage.vue';
import PaycheckTaxSummary from '@/components/Paycheck/PaycheckTaxSummary.vue';
import { GQL_workRelationPaycheckSums_workRelation_paycheckSums } from '@/queries/__generated__/workRelationPaycheckSums';
import PaycheckSumsFetcher from '@/components/Paycheck/PaycheckSumsFetcher.vue';

@Component({
  components: {
    PaycheckForm,
    DocumentPage,
    PaycheckTaxSummary,
    PaycheckSumsFetcher,
  },
})
export default class PaychecksPdf extends Vue {
  private GET_PAYCHECK = GET_PAYCHECK;
  @ProvideReactive() private isPdf = true;

  @ProvideReactive()
  private paycheckSums: GQL_workRelationPaycheckSums_workRelation_paycheckSums[] | null = null;

  private setPaycheckSums(paycheckSums: GQL_workRelationPaycheckSums_workRelation_paycheckSums[]) {
    this.paycheckSums = paycheckSums;
  }
}
